import { forceUpdate, h } from "@stencil/core";
import { i18nProvider } from "@trumpf/ux.i18n";
import loadTranslations from "../../utils/loadTranslations";
import { utcFromTime } from "../../utils/utcFromTime";
import { createPhoneLink } from "../../utils/createPhoneLink";
export class CreateServiceCaseSuccess {
    constructor() {
        /** Response from the API */
        this.response = null;
        /** Locale for the component */
        this.locale = null;
        /** BaseUrl for MyTrumpf */
        this.myTrumpfBaseUrl = "";
        /** used inside a modal */
        this.isInModal = false;
    }
    connectedCallback() {
        var _a;
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
        this.onLocaleChange();
        this.isInModal = ((_a = this.el) === null || _a === void 0 ? void 0 : _a.closest("ux-modal")) !== null;
    }
    disconnectedCallback() {
        i18nProvider.unsubscribe(this.i18nSubscriberId);
    }
    onLocaleChange() {
        if (this.locale !== i18nProvider.language) {
            this.loadTranslations();
        }
    }
    loadTranslations() {
        loadTranslations(this.locale).then((locale) => {
            i18nProvider.changeLanguage(locale);
            this.locale = locale;
        });
    }
    render() {
        var _a;
        const t = (key, options = undefined) => i18nProvider.t(`mf-service-calls:${String(key)}`, options);
        const time = (time) => time && h("ux-date-time", { key: '233498c6ddf993c5a98d4bdaea85af6b2bfdfccd', utc: utcFromTime(time), format: t("timeFormat") });
        const { isOutsideOfServiceHours, technicalServiceHotline, technicalGuideAvailable, isCustomerOrderNumberRequired, sisCaseId, serviceHours } = ((_a = this.response) === null || _a === void 0 ? void 0 : _a[0]) || {};
        const hasMonFri = Boolean((serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.MonFriStart) && (serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.MonFriEnd));
        const hasSat = Boolean((serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.SatStart) && (serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.SatEnd));
        const monFriHtml = hasMonFri && (h("div", { key: 'f81067eb1162c6d7c20502b40e6fc655efddd1ec' }, t("sisConnector.success.serviceTimes.MonFri"), " ", time(serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.MonFriStart), " - ", time(serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.MonFriEnd)));
        const satHtml = hasSat && (h("div", { key: 'a14204bbd97fb4568746ab5b1260efac742012fb' }, t("sisConnector.success.serviceTimes.Sat"), " ", time(serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.SatStart), " - ", time(serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.SatEnd)));
        return (h("div", { key: '28eb6893f010e226646da0702a6d4dc4a71a41ab', class: "ux-u-text-align--center" }, h("div", { key: '5adb9018b1773185abf4b604e45f87e45dc8bc25', class: "ux-u-mb-xxs" }, h("ux-icon", { key: 'f205af4ce9bc1b399cee03ce60b099b0bd134dab', style: { fontSize: "100px" }, class: "ux-color-success ux-icon", name: "checkmark" })), h("div", { key: '996c35c0460663d104994abb4e3603cef4506956', class: "ux-text-headline ux-text-headline--big ux-u-mb-xxs" }, t("sisConnector.success.headline")), isOutsideOfServiceHours && (h("div", { key: '15be170aacfe795788ada1bcfd8938d95934f1af', class: "ux-text-normal" }, h("p", { key: '9eb626cda611c1c8ef3258e78ea9f18190ede168' }, t("sisConnector.success.outsideOfServiceHours")), h("strong", { key: 'f495d851b6289faf17cd94c04ad4149df85f1531' }, monFriHtml, satHtml))), technicalServiceHotline && (h("p", { key: 'a35655181f7fd6391b4c8f194133395bca5d9dfd', class: "ux-text-normal", innerHTML: t("sisConnector.success.withTechnicalServiceHotline", {
                hotline: createPhoneLink(technicalServiceHotline, "mf-create-service-case-success__link"),
                interpolation: { escapeValue: false }
            }) })), !technicalServiceHotline && (h("p", { key: '5e88735548bd62bde1e26a0c427640f36e85e2eb', class: "ux-text-normal" }, t("sisConnector.success.withoutTechnicalServiceHotline"))), technicalGuideAvailable && (h("div", { key: 'cd5884ce763d003292849c7d0ab06af0efd26dc3' }, h("div", { key: 'bc4526979741b778f421626d8fbd66df3f3462db', class: "ux-text-headline--big" }, t("sisConnector.success.technicalGuide.title")), h("p", { key: '689206915596c622dd912f256052e28420365250', class: "ux-text-normal" }, t("sisConnector.success.technicalGuide.text")))), isCustomerOrderNumberRequired && (h("div", { key: '80929df07e3065c5244aa812e026cedcb1c4dfea' }, h("div", { key: 'ba3e477d2f9591d94356c47127f3e69f65e63640', class: "ux-text-headline--big" }, t("sisConnector.success.orderNumberRequired.title")), h("p", { key: 'aa18193e68dcfc1aa5cc8d04fdca18640bf8b2a7', class: "ux-text-normal" }, t("sisConnector.success.orderNumberRequired.text")))), h("div", { key: '307c84336cc51feed2c94f2c6de5934c91c49b7e', class: "ux-text-normal" }, h("p", { key: '7b84631edd8cf977f7b378f68562592c1de545c4' }, h("a", { key: '31227f7877d85c26749be939ec909e45e76da6a1', class: "mf-create-service-case-success__link", href: `${this.myTrumpfBaseUrl}/go/mytrumpf/my-service-cases/case/${sisCaseId}/` }, t("sisConnector.success.caseId"), ": ", sisCaseId))), !this.isInModal && (h("ux-button", { key: '8d21850ce10bf2a743e9f50b7712f593902828a4', class: "ux-u-margin-top-20", type: "button", variant: "primary", onClick: () => this.clickHandler(), formnovalidate: true }, t("button.ok")))));
    }
    static get is() { return "mf-create-service-case-success"; }
    static get originalStyleUrls() {
        return {
            "$": ["create-service-case-success.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["create-service-case-success.css"]
        };
    }
    static get properties() {
        return {
            "response": {
                "type": "unknown",
                "attribute": "response",
                "mutable": false,
                "complexType": {
                    "original": "CreateCaseResponse | null",
                    "resolved": "CreateCaseResponseItem[] | null",
                    "references": {
                        "CreateCaseResponse": {
                            "location": "import",
                            "path": "../../api/publicApi/createCase/createCase",
                            "id": "src/api/publicApi/createCase/createCase.ts::CreateCaseResponse"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Response from the API"
                },
                "getter": false,
                "setter": false,
                "defaultValue": "null"
            },
            "clickHandler": {
                "type": "unknown",
                "attribute": "click-handler",
                "mutable": false,
                "complexType": {
                    "original": "() => void",
                    "resolved": "() => void",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Click handler for the success button"
                },
                "getter": false,
                "setter": false
            },
            "locale": {
                "type": "string",
                "attribute": "locale",
                "mutable": false,
                "complexType": {
                    "original": "string | null",
                    "resolved": "null | string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Locale for the component"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "null"
            },
            "myTrumpfBaseUrl": {
                "type": "string",
                "attribute": "my-trumpf-base-url",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "BaseUrl for MyTrumpf"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "\"\""
            }
        };
    }
    static get states() {
        return {
            "isInModal": {}
        };
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "locale",
                "methodName": "onLocaleChange"
            }];
    }
}
//# sourceMappingURL=create-service-case-success.js.map
